export default __webpack_public_path__ + "static/media/pos_slideshow1.c0bc3ee5.jpg";